<template>
  <div class="suc">
    <div class="suc_head">
      <div class="suc_logo"></div>
    </div>
    <div class="suc_main">
      <div class="suc_main_box">
        <div class="l_1">
          <p>
            已收到您提交的会员申请信息，预计在<span>7-15个</span>工作日内将审核结果发送至您的邮箱。
          </p>
        </div>
        <div class="l_2">
          <p>
            如需更多帮助请联系MSC地中海邮轮官方服务热线
            <span
              ><a href="tel:400 820 0966" class="mark">400 8200 966</a></span
            >
            或邮件至<span>StatusMatch@msccruises.com</span>
          </p>
          <!-- <p>获取更多信息</p> -->
        </div>
        <div class="l_3">
          <div class="suc_qrcode">
            <img src="../assets/imgs/qrcode.jpeg" />
          </div>
          <div class="suc_qrcode_text">
            <p><span>扫描公众号</span></p>
            <p>获取更多咨询</p>
          </div>
        </div>
      </div>
      <div class="suc_main_foot">
        <span>*温馨提示：</span>
        根据MSC航海家俱乐部会员条款规定，请您务必在预订时提供您的会员卡号才能确保您能享受会员权益。
      </div>
    </div>
    <div class="suc_foot">
      <div class="suc_foot_bg">
        <div class="btn" @click="interestClick">查看会员权益</div>
        <div class="btn submit" @click="mscClick">立即预订</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "suc",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    interestClick() {
      this.$router.push({
        name: "interest",
        query: {
          url:
            "https://msccruises.oss-cn-shanghai.aliyuncs.com/policy/%E4%BC%9A%E5%91%98%E7%89%B9%E6%9D%83%E9%A1%B5%E9%9D%A2.jpg"
        }
      });
    },
    mscClick() {
      window.open("https://www.msccruises.com.cn");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/suc.vue